import React, { useState } from "react";
import { useProductStore } from "../../store/useProductStore";
import { useAuthStore } from "../../store/useAuthStore";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import ConfirmDialog from "../../components/Dialog/ConfirmDialog";
import orderService from "../../services/order.service";

const AddProductModal = ({ closeModal, subOrders =[], cartDataDetails = [], orderId }) => {
  const { isLoading, createOrder } = useProductStore();
  const { user } = useAuthStore();
  const [dialogVisible, setIsDialogVisible] = useState(false);

  const navigate = useNavigate();
  // console.log(cartDataDetails);
  subOrders = subOrders.filter(value => value.ordered_quantity > 0);
  const cartData = cartDataDetails.filter(value => value.ordered_quantity > 0);

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    let totalProduct = 0;

    cartData.forEach((item) => {
      const itemTotal = item.default_mrp * item.ordered_quantity * item.no_of_sets;
      const discount = itemTotal * ((item?.discount_percent ?? 0) / 100);
      totalPrice += itemTotal - discount;
      totalProduct += (item.ordered_quantity * item.no_of_sets || 0);
    });

    subOrders.forEach((item) => {
      totalPrice += item.billing_amount || 0;
      totalProduct += item.ordered_sets || 0;
    });

    return {totalPrice : totalPrice.toFixed(2), totalProduct};
  };

  const handleCreateOrder = async () => {
    if (cartData.length === 0) {
      toast.error(
        "Your cart is empty. Please add products before confirming the order."
        , {toastId: 'errorMessageHandleCreateOrder'});
      return;
    }

    // Extract only the product_id and ordered_quantity from the cart
    const orderData = [...cartData, ...subOrders]
    .filter(({ ordered_quantity }) => ordered_quantity > 0)
    .map(({ product_id, ordered_quantity }) => ({ product_id, ordered_quantity }));

    try {
      const body = {
        distributor_id: user.userDataObj.user_id,
        order_details: orderData,
        order_id : orderId,
      };
      const { status, message } = await orderService.updateOrder(body);
      if (status) {
        toast.success(message, {toastId: 'successMessageOrderData'});
        closeModal(false);
        navigate('/order-list',{state:{order_id : orderId}});
      } else {
        toast.error(message, {toastId: 'errorMessageHandleCreateOrder'});
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {toastId: 'errorMessageHandleCreateOrder'});
    }
  };

  console.log(cartData, "cartData");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-40">
      <div className="bg-white rounded-lg w-full max-w-4xl">
        <div className="p-6">
          <h2 className="text-2xl font-semibold text-teal-600 mb-4 text-center">
            Review Cart
          </h2>

          <div className="overflow-auto max-h-[350px]">
            <table className="w-full mb-4">
              <thead>
                <tr className="bg-emerald-200">
                  <th className="p-2 text-left">Part Number</th>
                  <th className="p-2 text-left">Size</th>
                  <th className="p-2 text-left">Make</th>
                  <th className="p-2 text-left">MRP Per Set</th>
                  <th className="p-2 text-left">Sets</th>
                  <th className="p-2 text-left">Billing Value</th>
                </tr>
              </thead>
              <tbody>
                {cartData.map((item, index) => (
                  <tr key={index} className="border-b bg-green-100">
                    <td className="p-2">{item.part_no}</td>
                    <td className="p-2">{item.size}</td>
                    <td className="p-2">{item.make}</td>
                    <td className="p-2">₹ {item.default_mrp}</td>
                    <td className="p-2 text-center">{item.ordered_quantity * item.no_of_sets}</td>
                    <td className="p-2">
                      ₹ {((item.default_mrp * item.ordered_quantity * item.no_of_sets) - 
                          ((item.default_mrp * item.ordered_quantity * item.no_of_sets) * ((item?.discount_percent ?? 0) / 100))
                        ).toFixed(2)}
                    </td>
                  </tr>
                ))}

                {subOrders.map((item, index) => (
                  <tr key={`existing-${index}`} className="border-b bg-gray-100">
                    <td className="p-2">{item?.skuMaster?.part_no}</td>
                    <td className="p-2">{item?.skuMaster?.skuSize?.size}</td>
                    <td className="p-2">{item?.skuMaster?.skuMake?.make}</td>
                    <td className="p-2">₹ {item.product_amount}</td>
                    <td className="p-2 text-center">{item.ordered_sets }</td>
                    <td className="p-2">
                      ₹ {(item.billing_amount).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr className="text-teal-800 font-bold" >
                  <td colSpan={4} className="p-2">Total</td>
                  <td className="p-2 text-center">{calculateTotalPrice().totalProduct}</td>
                  <td className="p-2">₹ {calculateTotalPrice().totalPrice}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* <div className="space-y-2">
            <div className="flex justify-evenly text-teal-800 font-bold">
              <span className="font-semibold">Total Billing Price</span>
              <span>₹ {calculateTotalPrice()}</span>
            </div>
          </div> */}

          {isLoading ? (
            <Loader />
          ) : (
            <div className="flex justify-center gap-4 mt-6">
              {cartData.length > 0 && (
                <button
                  onClick={() => setIsDialogVisible(true)}
                  className="px-12 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
                >
                  Confirm
                </button>
              )}
              <button
                onClick={() => closeModal(false)}
                className="px-12 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>

      <ConfirmDialog
        isOpen={dialogVisible}
        setIsOpen={setIsDialogVisible}
        handler={handleCreateOrder}
        title="Confirmation"
        message="Are you sure you would like to confirm your order ?"
        position="center"
      />
    </div>
  );
};

export default AddProductModal;